export default __webpack_public_path__ + "static/media/bdedu2.9c814edd.PNG";